import { ChatBubbleIcon } from '../../assets/svgImages';
import { BannerSlide } from '../../interface/interface';
import { Naturopath_url } from '../../constant/constant';

export const getBannerSlides = (isGuest: boolean): BannerSlide[] => [
  {
    id: 'speak-to-naturopath',
    eyebrow: {
      text: 'Complimentary Service',
      icon: <ChatBubbleIcon className="h-4 w-4" />,
    },
    heading: (
      <>
        Speak to our{' '}
        <span className="block text-secondary-pink-500">Naturopath</span>
      </>
    ),
    description:
      'Not sure where to start? Book a complimentary chat with our naturopath for personalised product guidance.',
    button: {
      label: 'Book Your Free Chat',
      href: Naturopath_url,
    },
    image: {
      src: '/banners/naturopath-banner.png',
      alt: 'A naturopath in a white shirt smiling while consulting with a patient across a desk lined with supplements.',
    },
  },
  {
    id: 'heart-health_support',
    eyebrow: {
      text: 'Herbal Support for Modern Life',
    },
    heading: (
      <>
        Find Your Calm with{' '}
        <span className="block text-secondary-pink-500">SuperFeast</span>
      </>
    ),
    description:
      'Discover Ashwagandha Capsules, traditionally used to support the nervous system, emotional balance and healthe sleep.',
    button: {
      label: 'Explore SuperFeast Range →',
      href: isGuest ? '/guest/shop-non-script' : '/non-script-range',
    },
    image: {
      src: '/banners/superfeast-product.png',
      alt: 'Discover Ashwagandha Capsules, traditionally used to support the nervous system, emotional balance and healthe sleep.',
    },
  },
];
